import { brandConfig } from '../../config/brands';
import { useUser } from '../auth/useUser';

/**
 * バナーレイアウトエディタを出すか (フラグ bannerLayoutEditor)。
 * 既定で全員に公開。ブランドで明示的に false にしたときだけ platform admin に限る (useUploadFeedback と同じ判定)。
 */
export function useBannerLayoutEditorEnabled(): boolean {
  const { isPlatformOrg, isAdmin, hasPlatformAdminMembership } = useUser();
  if (brandConfig.features.bannerLayoutEditor !== false) return true;
  return (isPlatformOrg && isAdmin) || hasPlatformAdminMembership;
}
